import { render, staticRenderFns } from "./ChildSubMenuItem.vue?vue&type=template&id=161d4759"
import script from "./ChildSubMenuItem.vue?vue&type=script&lang=js"
export * from "./ChildSubMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ChildSubMenuItem.vue?vue&type=style&index=0&id=161d4759&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports